import React, { useEffect, useState } from "react";
import { PGET } from "../../../api/adminApi";
import CustomDatePicker from "../../common/CustomDatePicker";
import { Bar } from "react-chartjs-2";
import PropTypes from "prop-types";
import moment from "moment/moment";
import Select from "react-select";

export const KotelDashboard = (props) => {
  const { options, height, layout } = props;
  const [dashboardData, setDashboardData] = useState([]);
  const [dateRange, setDateRange] = useState([
    new Date("2026-01-01"),
    new Date("2027-01-01"),
  ]);
  const [startDate, endDate] = dateRange;
  const [selectedOption, setSelectedOption] = useState({
    label: "Секционный",
    value: 1,
  });

  const selectOptions = [
    { label: "Секционный", value: 1 },
    { label: "Панельный", value: 2 },
    { label: "Котел", value: 3 },
  ];

  async function getDashboardMonthCounts() {
    if (startDate && endDate) {
      const data = await PGET(
        "/services/admin/api/dashboard-region-counts/",
        true,
        {
          dateFrom: moment(startDate).format("YYYY-MM-DD"),
          dateTo: moment(endDate).add(1, "day").format("YYYY-MM-DD"),
          category: selectedOption.value,
        }
      );
      if (data) {
        setDashboardData(data.data);
      }
    }
  }

  // Calculate percentages
  const percentages = dashboardData.map((item) => {
    if (item.salesCount === 0) return 0;
    return ((item.mountCount / item.salesCount) * 100).toFixed(1);
  });

  const data = {
    labels: dashboardData.map((item) => item.regionName),
    datasets: [
      {
        label: "Продажа",
        data: dashboardData.map((item) => item.salesCount),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Установка",
        data: dashboardData.map((item) => item.mountCount),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  useEffect(() => {
    getDashboardMonthCounts();
  }, [startDate, endDate, selectedOption]);

  return (
    <div className="h-[400px] relative">
      {/* Date Range Picker */}
      <div
        style={{
          width: 200,
          position: "absolute",
          right: 220,
          top: 20,
          zIndex: 10,
        }}
      >
        <CustomDatePicker
          startDate={startDate}
          endDate={endDate}
          onChange={(update) => setDateRange(update)}
          className="datepicker-custom-input-dash"
        />
      </div>

      {/* Category Select */}
      <div
        style={{
          width: 200,
          position: "absolute",
          right: 10,
          top: 20,
          zIndex: 10,
        }}
      >
        <Select
          name="sr"
          className="custom-react-select"
          options={selectOptions}
          value={selectedOption}
          onChange={(opt) => setSelectedOption(opt)}
        />
      </div>

      {/* Bar Chart */}
      <Bar
        data={data}
        height={height}
        options={{
          ...options,
          ...layout,
          plugins: {
            ...options?.plugins,
            tooltip: {
              enabled: true,
              callbacks: {
                afterLabel: function (ctx) {
                  if (ctx.datasetIndex === 1 && percentages.length > 0) {
                    return `Процент от продаж: ${percentages[ctx.dataIndex]}%`;
                  }
                  return "";
                },
              },
            },
          },
        }}
      />

      {/* Bottom Percentage Panel */}
      <div
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "space-around",
          fontSize: "8px",
          color: "#666",
        }}
      >
        {dashboardData.map((item, i) => (
          <div key={i} style={{ textAlign: "center" }}>
            <div>{item.regionName}</div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "10px",
                color: "rgba(53, 162, 235, 1)",
              }}
            >
              {percentages[i]}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

KotelDashboard.defaultProps = {
  options: {
    maintainAspectRatio: true,
    responsive: true,
    layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },
    plugins: { legend: { position: "top" }, title: { display: true } },
  },
};

KotelDashboard.propTypes = {
  height: PropTypes.number,
  labels: PropTypes.arrayOf(PropTypes.string),
  datasets: PropTypes.arrayOf(PropTypes.object),
  options: PropTypes.object,
  layout: PropTypes.object,
};
